// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3JJK_","footer":"ModalUpdate_footer__3IILt"};